"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Languages = function (_a) {
    var languages = _a.languages;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var currentLang = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('languages');
    var getPageWithNewLang = (0, apps_shared_1.usePageWithNewLang)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.languages },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.label, onClick: function () { return setIsOpen(true); } },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.listItemIcon, src: "/img/langFlags/".concat(currentLang, ".svg"), alt: "icon" }),
            react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink) }, t(currentLang))),
        isOpen && (react_1.default.createElement("div", { className: styles_module_scss_1.default.blur, onClick: function () { return setIsOpen(false); } })),
        isOpen && (react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, languages.map(function (lang) {
            return (react_1.default.createElement("div", { key: "lang".concat(lang.key) },
                react_1.default.createElement("a", { href: getPageWithNewLang(lang.key), key: lang.key, className: "".concat(styles_module_scss_1.default.currentLangItem, " ").concat(currentLang === lang.key ? styles_module_scss_1.default.langActive : '') },
                    react_1.default.createElement(image_1.default, { src: "/img/langFlags/".concat(lang.key, ".svg"), alt: lang.title + ' flag', width: 24, height: 24 }),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.langText },
                        " ",
                        t(lang.key)))));
        })))));
};
exports.default = Languages;
